// extracted by mini-css-extract-plugin
export default {"returnButtonWrapper":"styles_returnButtonWrapper__ZuYPm"};